

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { walletPinCodeTypes } from '../statuses';

export default class WalletPinCodesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-pin-codes';
        this.Server = this.props.context.getState().server.walletPinCodes;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['code'];

        const defaultHead = [
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'phone',
                label: 'phone',
                alignRight: false,
                cell: 'Phone',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'code',
                label: 'code',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'type',
                label: 'type',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletPinCodeTypes)
            },
            {
                id: 'attempts',
                label: 'attempts',
                alignRight: true,
                cell: 'Number',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'dateExpired',
                label: 'dateExpired',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'isUsed',
                label: 'isUsed',
                alignRight: false,
                cell: 'Enable',
                displayGrid: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

